import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useUserStore } from "../store/user";

export function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const verifyToken = useUserStore((s) => s.verifyToken);
  const [phase, setPhase] = useState<"verifying" | "error">("verifying");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setPhase("error");
      setError("no token in link");
      return;
    }
    let cancelled = false;
    verifyToken(token)
      .then(() => {
        if (!cancelled) navigate("/play", { replace: true });
      })
      .catch((e) => {
        if (cancelled) return;
        setPhase("error");
        setError(e instanceof Error ? e.message : "verification failed");
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-md mx-auto pt-16 text-center">
      {phase === "verifying" ? (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <motion.div
            className="w-10 h-10 mx-auto rounded-full border-2 border-accent/30 border-t-accent"
            animate={{ rotate: 360 }}
            transition={{ duration: 0.9, repeat: Infinity, ease: "linear" }}
          />
          <p className="text-ink-400 mt-4 text-sm">signing you in…</p>
        </motion.div>
      ) : (
        <motion.div initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="font-display text-3xl mb-2">couldn't sign you in</h1>
          <p className="text-ink-400 text-sm mb-6">{error}</p>
          <Link
            to="/login"
            className="inline-block px-5 py-2 rounded-xl bg-accent text-ink-950 font-medium hover:opacity-90"
          >
            request a new link
          </Link>
        </motion.div>
      )}
    </div>
  );
}
